"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceProfileToJSON = exports.VoiceProfileFromJSONTyped = exports.VoiceProfileFromJSON = exports.instanceOfVoiceProfile = void 0;
var runtime_1 = require("../runtime");
var VoiceType_1 = require("./VoiceType");
/**
 * Check if a given object implements the VoiceProfile interface.
 */
function instanceOfVoiceProfile(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfVoiceProfile = instanceOfVoiceProfile;
function VoiceProfileFromJSON(json) {
    return VoiceProfileFromJSONTyped(json, false);
}
exports.VoiceProfileFromJSON = VoiceProfileFromJSON;
function VoiceProfileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'sampleUrl': !(0, runtime_1.exists)(json, 'sample_url') ? undefined : json['sample_url'],
        'voiceType': !(0, runtime_1.exists)(json, 'voice_type') ? undefined : (0, VoiceType_1.VoiceTypeFromJSON)(json['voice_type']),
    };
}
exports.VoiceProfileFromJSONTyped = VoiceProfileFromJSONTyped;
function VoiceProfileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'language': value.language,
        'sample_url': value.sampleUrl,
        'voice_type': (0, VoiceType_1.VoiceTypeToJSON)(value.voiceType),
    };
}
exports.VoiceProfileToJSON = VoiceProfileToJSON;
